<template>

    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <div class="o-text" v-html="field.CKeditorField">
        </div>
    </div>

</template>

<script>

    export default {
        name: 'RichText',
        props: {
        	field:{
        		type: Object,
                default() {
                    return {}
                },
        	},
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
    }

</script>